{
	"orders": {
		"ticker": "Ticker",
		"tickerCompany": "Ticker/Company",
		"operation": "Operation",
		"quantity": "Quantity",
		"sum": "Sum",
		"executed": "Executed",
		"profitability": "Profit",
		"dateTime": "Date/Time",
		"price": "Price",
		"openedOrders": "Opened Orders",
		"complexOrders": "Order Group",
		"statusTitle": "Status",
		"term": "Term",
		"orderStatus": "Order Status",
		"orderType": "Order Type",
		"info": "Info",
		"pcs": "pcs",
		"total": "Total",
		"status": {
			"new": "New",
			"partially_filled": "Partially Filled",
			"filled": "Filled",
			"done_for_day": "Done For Day",
			"canceled": "Canceled",
			"expired": "Expired",
			"replaced": "Replaced",
			"pending_cancel": "Pending Cancel",
			"pending_replace": "Pending Replace",
			"accepted": "Accepted",
			"pending_new": "Pending New",
			"rejected": "Rejected",
			"calculated": "Calculated",
			"accepted_for_bidding": "Accepted for Bidding",
			"stopped": "Stopped",
			"suspended": "Suspended",
			"held": "Held"
		},
		"side": {
			"buy": "Buy",
			"sell": "Sell",
			"sell_short": "Sell Short"
		},
		"activeOrders": {
			"filled": "Filled",
			"open": "Open",
			"canceled": "Canceled"
		},
		"types": {
			"market": "Market",
			"limit": "Limit",
			"stop": "Stop",
			"stop_limit": "Stop Limit",
			"trailing_stop": "Trailing Stop"
		},
		"attributes": {
			"stop_loss": "Stop Loss",
			"take_profit": "Take Profit"
		},
		"terms": {
			"day": "DAY",
			"gtc": "GTC",
			"opg": "OPG",
			"cls": "CLS",
			"ioc": "IOC",
			"dayPlus": "DAY+"
		},
		"orderSuccessfullyCanceled": "The order was successfully cancelled!",
		"empty": "No orders",
		"cancel": "Cancel",
		"edit": "Edit"
	}
}
